import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useFormDispatch, updateField } from './FormStateMachine';

const URLStateInitializer = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useFormDispatch();

  useEffect(() => {
    const validParams = {
      plan: (value) => updateField(dispatch, 'plan', value),
      sponsorId: (value) => updateField(dispatch, 'sponsorId', value),
      subscriptionLength: (value) => updateField(dispatch, 'subscriptionLength', value),
      promoCode: (value) => updateField(dispatch, 'promoCode', value),
      referral: (value) => updateField(dispatch, 'referral', value)
    };

    for (let [key, value] of searchParams.entries()) {
      if (validParams[key]) {
        validParams[key](value);
      }
    }
  }, [searchParams, dispatch]);

  return null; // This component does not render anything
};

export default URLStateInitializer; 
